import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeIOSKeyboardFix } from './utils/iosKeyboardFix';

// Suppress Firebase reCAPTCHA timeout errors (non-critical console spam)
const originalConsoleError = console.error;
console.error = (...args: any[]) => {
  // Filter out Firebase reCAPTCHA timeout errors
  const errorString = args.join(' ');
  if (
    errorString.includes('Timeout') &&
    errorString.includes('handleError') &&
    args[0]?.name === 'u'
  ) {
    // Silently ignore Firebase reCAPTCHA timeout errors
    return;
  }

  // Log all other errors normally
  originalConsoleError.apply(console, args);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Initialize iOS keyboard fix after DOM is ready
if (typeof window !== 'undefined') {
  // Wait for DOM to be fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeIOSKeyboardFix);
  } else {
    // DOM is already loaded
    initializeIOSKeyboardFix();
  }

  // Also reinitialize on route changes (for dynamic inputs)
  let previousPath = window.location.pathname;
  setInterval(() => {
    if (window.location.pathname !== previousPath) {
      previousPath = window.location.pathname;
      setTimeout(initializeIOSKeyboardFix, 500);
    }
  }, 1000);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
